import React, {useEffect, useState} from "react";
import {ClipboardText} from "@phosphor-icons/react";
import {Tab} from "../../../../components";
import {BuilderAtributesTab} from "./BuilderAtributesTab";
import EngineeringSection from "../EngineeringSection/EngineeringSection";
import {useViewerStore} from "../../../../store/store";

const BuildingAttributes: React.FC = () => {
    const pathname = useViewerStore((state) => state.pathname)
    const [isEngineering, setIsEngineering] = useState(false);

    useEffect(() => {
        if (pathname.includes("engineering-letter")) {
            setIsEngineering(true);
        } else if (pathname.includes("engineering-affidavit")) {
            setIsEngineering(true);
        } else {
            setIsEngineering(false);
        }
    }, [pathname]);

    return (
        <>
            <Tab items={[
                {
                    icon: <ClipboardText size={24} weight="fill" />,
                    content: <BuilderAtributesTab />,
                    title: "Building Attributes",
                    is_active: true,
                    ...(isEngineering && {secondcontent: <EngineeringSection/>}),
                },
            ]} isMultiMenu={isEngineering} />
        </>
    );
};

export default BuildingAttributes;
